// extracted by mini-css-extract-plugin
export var callCard = "_sd-0";
export var callMessageButton = "_sd-1";
export var helpIcon = "_sd-3";
export var helpIconContainer = "_sd-4";
export var verticalDivider = "_sd-2";